import React from 'react';
import { Alert } from '@duxton-web/ui';

import { AXA_WARNING_MESSAGES } from '@/features/experiment/utils';

interface AxaWarningAlertProps {
  show: boolean;
  type: keyof typeof AXA_WARNING_MESSAGES;
  style?: React.CSSProperties;
}

const AxaWarningAlert = ({ show, type, style }: AxaWarningAlertProps) => {
  if (!show) return null;

  // Preserve default styles unless explicitly overridden
  const mergedStyle: React.CSSProperties = {
    width: style?.width ?? 'fit-content',
    alignSelf: style?.alignSelf ?? 'center',
    ...style,
  };

  return (
    <Alert
      style={mergedStyle}
      message={AXA_WARNING_MESSAGES[type]}
      type="warning"
      showIcon
    />
  );
};

export default AxaWarningAlert;
